import { MavChartArea } from './mav-chart-area';

export { MavChartArea };
